require("./m-quote.scss");


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/molecule/m-quote/m-quote.chunk.js